import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replaceDoubleLinebreak' })
export class ReplaceDoubleLinebreakPipe implements PipeTransform {
    public transform(value: string): string {
        if (value) {
            return value.replace(/\\n/g, '\n');
        }

        return '';
    }
}
